// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11bc091b","337":"21ac26b9","667":"e2321766"}[chunkId] + ".chunk.js";
};